export default "__VITE_ASSET__CjA_S85f__"